const BASE_URL =
  process.env.NODE_ENV === "production"
    ? "/reco/api/ai-compare"
    : "http://k8s-machinecraftmain-f16cc05195-1227403734.ap-northeast-3.elb.amazonaws.com/reco/api/ai-compare";

const API_KEY = "reco-api-550e8400e29b41d4a716446655440000";

export type CompareProduct = any;

const yieldToBrowser = async () => {
  await new Promise<void>((resolve) => {
    requestAnimationFrame(() => resolve());
  });
};

export async function startAiCompareStream(
  products: CompareProduct[],
  onChunk: (text: string) => void,
  onDone: () => void,
  onError: (e: unknown) => void,
  signal?: AbortSignal
) {
  try {
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/event-stream",
        "x-api-key": API_KEY,
      },
      body: JSON.stringify({
        product_ids: products.map((p) => p.id),
        products,
      }),
      signal,
    });

    if (!res.ok || !res.body) {
      throw new Error(`ai-compare API request failed: ${res.status}`);
    }

    const reader = res.body.getReader();
    const decoder = new TextDecoder("utf-8");

    let buffer = "";

    while (true) {
      const { value, done } = await reader.read();

      if (value) {
        buffer += decoder.decode(value, { stream: true });

        const events = buffer.split(/\r?\n\r?\n/);
        buffer = events.pop() ?? "";

        for (const eventText of events) {
          const lines = eventText.split(/\r?\n/);

          const dataLines = lines
            .filter((line) => line.startsWith("data:"))
            .map((line) => line.replace(/^data:\s?/, ""));

          if (dataLines.length === 0) continue;

          const data = dataLines.join("\n");

          if (data === "[DONE]") {
            onDone();
            return;
          }

          onChunk(data.replace(/\\n/g, "\n"));
          await yieldToBrowser();
        }
      }

      if (done) {
        const lastEvent = buffer.trim();
        if (lastEvent) {
          const lines = lastEvent.split(/\r?\n/);
          const dataLines = lines
            .filter((line) => line.startsWith("data:"))
            .map((line) => line.replace(/^data:\s?/, ""));

          const data = dataLines.join("\n");
          if (data && data !== "[DONE]") {
            onChunk(data.replace(/\\n/g, "\n"));
            await yieldToBrowser();
          }
        }

        onDone();
        return;
      }
    }
  } catch (e) {
    onError(e);
  }
}